import React from "react";
import { getFormattedNames } from "../../lib/wowHelpers";
import { ReactComponent as OpenPageIcon } from "svg/share-box-line.svg";

const SquareGuidePromo = ({ classType, guideDescription, guideLink, guideTitle, specType }) => {
  const { displayClassName, displaySpecName, dataClassName, dataSpecName } = getFormattedNames(classType, specType);

  return (
    <div className="square-guide-promo-container">
      <a href={guideLink} target="_blank">
        <div
          className="square-guide-promo-image"
          style={{ backgroundImage: `url("https://static.bigbrain.gg/wow/specs/${classType}_${specType}.png")` }}
        />
        <div className="promo-content">
          <div className="class-spec-container">
            <img
              className="spec-img"
              src={`https://static.bigbrain.gg/wow/spec-icons/${dataClassName}-${dataSpecName}.jpg`}
              alt={`${displaySpecName} ${displayClassName}`}
            />
            {displaySpecName} {displayClassName}
          </div>
          <div className="guide-title">{guideTitle}</div>
          <div className="guide-description">{guideDescription}</div>
        </div>
        <div className="guide-button">
          Read Guide <OpenPageIcon className="open-page-icon" />
        </div>
      </a>
    </div>
  );
};

export default SquareGuidePromo;
